module.exports = __webpack_public_path__ + "img/screen-full.41b5b53c.jpg";